module.exports = __webpack_public_path__ + "img/Eaton.757d5142.png";